import { mergeProps } from "@base-ui/react/merge-props";
import { useRender } from "@base-ui/react/use-render";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

/* eslint-disable react-refresh/only-export-components -- shadcn co-locates the variant helper with its component */

const badgeVariants = cva(
  "group/badge inline-flex min-h-6 w-fit shrink-0 items-center justify-center gap-1.5 overflow-hidden rounded-full border-0 px-3 py-0.5 font-sans text-xs font-semibold whitespace-nowrap transition-[color,background-color,box-shadow] duration-150 focus-visible:shadow-[var(--focus-ring)] has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2 aria-invalid:border-destructive [&>svg]:pointer-events-none [&>svg]:size-3.5!",
  {
    variants: {
      variant: {
        default: "bg-info-background text-link",
        secondary: "bg-muted text-muted-foreground",
        success: "bg-success-background text-success",
        warning: "bg-warning-background text-warning",
        destructive: "bg-destructive-background text-destructive",
        outline: "bg-muted text-muted-foreground",
        ghost: "bg-transparent text-muted-foreground hover:bg-muted",
        link: "text-link underline-offset-4 hover:underline",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

function Badge({
  className,
  variant = "default",
  render,
  ...props
}: useRender.ComponentProps<"span"> & VariantProps<typeof badgeVariants>) {
  return useRender({
    defaultTagName: "span",
    props: mergeProps<"span">(
      {
        className: cn(badgeVariants({ variant }), className),
      },
      props,
    ),
    render,
    state: {
      slot: "badge",
      variant,
    },
  });
}

export { Badge, badgeVariants };
